import Ellipsis from "../Ellipsis";
import { CustomTypographyH5, CustomTypographyH6 } from "./style";

interface TypographyProps {
  className?: string;
  ellipsis?: boolean;
  ellipsisWidth?: number;
  children: string;
}

export const TypographyH5 = (props: TypographyProps) => {
  const { children, className, ellipsis, ellipsisWidth } = props;
  return (
    <CustomTypographyH5 className={className} variant="h5">
      {ellipsis ? (
        <Ellipsis width={ellipsisWidth}>{children}</Ellipsis>
      ) : (
        children
      )}
    </CustomTypographyH5>
  );
};

TypographyH5.defaultProps = {
  className: "",
  ellipsis: false,
  ellipsisWidth: 100,
};

export const TypographyH6 = (props: TypographyProps) => {
  const { children, className, ellipsis, ellipsisWidth } = props;
  return (
    <CustomTypographyH6 className={className} variant="h6">
      {ellipsis ? (
        <Ellipsis width={ellipsisWidth}>{children}</Ellipsis>
      ) : (
        children
      )}
    </CustomTypographyH6>
  );
};

TypographyH6.defaultProps = {
  className: "",
  ellipsis: false,
  ellipsisWidth: 100,
};
